import React, { useEffect, useState } from "react";


import { Grid, Button } from "@mui/material";


const SaveToDraft = ({ miniScreen, handleCloseModal, handleNavigate }) => {

  return (
        <div className="flex justify-center">
          <Grid
            container
            direction="column"
            justifyContent="space-between"
            alignItems="right"
            style={{ backgroundColor: '#FFFFFF', padding: `${miniScreen ? '10px 15px 7px 15px' : '40px 50px 30px 50px'}`, borderRadius: '4.27px', boxShadow: '0px 4px 30px 0px #00000040'}}
          >
            <div className="absolute md:top-10 top-6 md:right-11 right-6  cursor-pointer" onClick={handleCloseModal}><img src="./closeIcon.svg" alt="" /></div>
            <h1 className="md:text-2xl text-base font-semibold">Save as draft?</h1>
            <p className="md:text-lg text-sm mt-3 font-normal">This page has unsaved changes. Do you want to save profile as draft before leaving the page?</p>
            <div className="flex items-center mt-3">
                <input type="button" className='bg-blue-8 w-5/12 h-auto text-white-1 rounded md:py-3 md:px-4 p-2 text-center cursor-pointer' value="Save as draft" onClick={()=>handleNavigate('save')} />
                <div className="ml-3 font-normal cursor-pointer" onClick={handleNavigate}>Discard</div>
            </div>
          </Grid>
        </div>
    );
};

export default SaveToDraft;
